// src/data/staticData.js

import hero1 from "../assets/home/Hero1.png";
import hero2 from "../assets/home/Hero2.png";

export const heroThemes = [
  {
    heading: "WELCOME TO SELVA'S IAS ACADEMY",
    subheading: "Build your career with Selva's IAS Academy.",
    fileUrl: hero1,
  },
  {
    heading: "WELCOME TO SELVA'S IAS ACADEMY",
    subheading: "Your journey to success starts here.",
    fileUrl: hero2,
  },
];

export const currentAffairsData = [
  {
    _id: "1",
    title: "Daily Current Affairs Digest",
    description: "Comprehensive coverage of today's important news.",
    filterType: "Daily",
    createdAt: new Date().toISOString(),
    fileUrl: null,
  },
  {
    _id: "2",
    title: "Monthly Current Affairs Magazine",
    description: "Detailed analysis for the entire month.",
    filterType: "Monthly",
    month: new Date().toLocaleString("default", { month: "long" }),
    year: new Date().getFullYear().toString(),
    createdAt: new Date().toISOString(),
    fileUrl: null,
  }
];

export const dawQuestions = [
  {
    _id: "1",
    examTitle: "General Studies Paper 1",
    subject: "History & Geography",
    questions: [
      "Discuss the impact of the Swadeshi Movement on the Indian National Movement.",
      "Analyze the factors responsible for the location of the cotton textile industry in India."
    ]
  },
  {
    _id: "2",
    examTitle: "General Studies Paper 2",
    subject: "Polity & Governance",
    questions: [
      "Examine the role of the Election Commission of India in ensuring free and fair elections.",
      "Discuss the significance of the Right to Information Act in promoting transparency."
    ]
  }
];

export const pyqsData = [
  {
    _id: "1",
    title: "UPSC Prelims GS 2023",
    subject: "GS",
    year: "2023",
    filePath: null
  },
  {
    _id: "2",
    title: "UPSC Prelims CSAT 2023",
    subject: "CSAT",
    year: "2023",
    filePath: null
  },
  {
    _id: "3",
    title: "Mains",
    subject: "Essay",
    year: "2023",
    filePath: null
  },
  {
    _id: "4",
    title: "Optional",
    subject: "Anthropology",
    year: "2023",
    filePath: null
  }
];
